import { render, staticRenderFns } from "./fccLiberacao.vue?vue&type=template&id=0469d35a"
import script from "./fccLiberacao.vue?vue&type=script&lang=js"
export * from "./fccLiberacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports